import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {GroupMember, LearningUnitTeacherStatus, V3GroupStudent, V3GroupTeacher} from "../../../model/v3/schools";
import {Page} from "../../../model/server";

@Component({
    selector: 'app-group-participant-list',
    templateUrl: './group-participant-list.component.html',
    styleUrls: ['./group-participant-list.component.scss'],
    standalone: false
})
export class GroupParticipantListComponent implements OnInit {

  @Input() participants: Page<V3GroupTeacher> | Page<V3GroupStudent>
  @Input() isEdited = false
  @Output() editPartiEvent = new EventEmitter<V3GroupTeacher | V3GroupStudent>()
  @Output() deletePartiEvent = new EventEmitter<V3GroupTeacher | V3GroupStudent>()
  constructor() { }

  ngOnInit(): void {
  }

  getName(parti: V3GroupTeacher | V3GroupStudent) {
    return `${parti.member.person.details.name} ${parti.member.person.details.surname}`
  }

  getStatus(parti: V3GroupTeacher | V3GroupStudent) {
    return parti.member.status
  }

  getStatusBadgeClass(parti: V3GroupTeacher | V3GroupStudent) {
    switch (parti.member.status) {
      case LearningUnitTeacherStatus.ACTIVE: return 'bg-primary';
      case LearningUnitTeacherStatus.BLOCKED: return 'bg-secondary';
      case LearningUnitTeacherStatus.REMOVED: return 'bg-danger';
      default: return 'bg-primary'
    }

  }

  getEmail(parti: V3GroupTeacher | V3GroupStudent) {
    return parti.member.person.registrationEmail
  }

  getDateFrom(parti: GroupMember<any>) {
    return parti.from ? new Date(parti.from).toLocaleDateString() : '-'
  }

  getDateTo(parti: GroupMember<any>) {
    return parti.to ? new Date(parti.to).toLocaleDateString() : '-'
  }

  getLabels(parti: GroupMember<any>) {
    return Array.from(parti.labels.values()).join(', ') || '-'
  }

  editParticipant(parti: V3GroupTeacher | V3GroupStudent) {
    this.editPartiEvent.emit(parti)
  }

  deleteParticipant(parti: V3GroupTeacher | V3GroupStudent) {
    this.deletePartiEvent.emit(parti)
  }
}
